module.exports = __webpack_public_path__ + "static/media/amulet_09.cb1da54c.png";